import { Typography } from '@breetometer/components';
import { InfoIcon } from 'BreetAssets';
import { viewHelpArticle } from 'BreetHelpers';

export const InfoArticle = ({ text, articleNumber }: { text: string; articleNumber: string }) => (
	<div className='funding-article'>
		<InfoIcon className='info-icon svg-dark' />
		<Typography
			as='a'
			onClick={viewHelpArticle(articleNumber)}
			className='color-tertiary-300 tertiary-txt-link-hover'
		>
			{text}
		</Typography>
	</div>
);
